<script>
import ModelCreateModal from './modal-create';
import FormsModel from "@/components/forms/driver";

export default {
  name: 'DriverCreateModal',
  extends: ModelCreateModal,
  props: {
    modalTitle: {default() { return this.lodash.startCase(this.$t('drivers.singular')) }},
    resourceRoute: {default: 'drivers'},
    modelVariable: {default: 'driver'},
    form: {default() { return FormsModel; }}
  },
  methods: {
    store(value) {
      return this.$axios.post('/drivers', value);
    }
  },
}
</script>
